import { Grid2, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button, Chip, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProfileAnalysisHeaderProps as Props } from './types';

export const ProfileAnalysisHeader = memo(
  ({ className, archetype, confidenceScore, onDetailsClick }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('ProfileAnalysisHeader', className)}
        sx={SX.root}
      >
        <Typography variant="h6" fontWeight={700} color="primary.700">
          {archetype}
        </Typography>
        <Grid2 direction="row" alignItems="center" gap={0.5}>
          <Chip
            variant="filled"
            color="success"
            size="small"
            label={`${confidenceScore}% - Confidence`}
          />

          <Button
            size="xsmall"
            variant="outlined"
            endIcon={<Icon name="chevron-right" />}
            onClick={onDetailsClick}
          >
            View Full Details
          </Button>
        </Grid2>
      </Styled.Wrapper>
    );
  }
);

ProfileAnalysisHeader.displayName = 'ProfileAnalysisHeader';
